var exports = {
  "kL": "x61f99309--784e2e--container",
  "o1": "x61f99309--784e2e--actions",
  "Qs": "x61f99309--784e2e--content",
  "hn": "x61f99309--784e2e--icon-button",
  "sv": "x61f99309--784e2e--edit-button",
  "rd": "x61f99309--784e2e--delete-button",
};

module.exports = exports;
